import { render, staticRenderFns } from "./TypesFilter.vue?vue&type=template&id=b0882d16&scoped=true&"
import script from "./TypesFilter.vue?vue&type=script&lang=js&"
export * from "./TypesFilter.vue?vue&type=script&lang=js&"
import style0 from "./TypesFilter.vue?vue&type=style&index=0&id=b0882d16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0882d16",
  null
  
)

export default component.exports